import { Logger } from '~~/helpers/logger';
import { SEO_REDIRECTION_CODE, NON_PUBLISHED_OR_NON_ELIGIBLE_REDIRECTION_CODE } from '~~/constants/seo';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { productGetters } from '~/utils/ct';
import { ROUTES } from '~~/constants/routes';

type ProductRedirectTarget = {
  to: string;
  redirectCode: number;
};

export default function () {

  const { getAdjustedSlug } = useRouteExtended();

  const isRedirecting = useState('isRedirecting', () => false);

  const createRedirectTarget = (to: string, redirectCode: number): ProductRedirectTarget => {

    isRedirecting.value = true;

    return {
      to,
      redirectCode,
    };

  };

  const redirectIfProductSlugMismatch = (currentSlug: string, product: ProductVariantExtended) => {

    const productSlug = product?._slug;

    if (productSlug && (productSlug !== currentSlug)) {

      Logger.warn(`Product slug mismatch for: ${currentSlug}. Redirecting to: ${productSlug}`);

      return createRedirectTarget(productSlug, SEO_REDIRECTION_CODE);

    }

  };

  const redirectIfNotPublishedOrNotEligibleForSelling = (product: Ref<ProductVariantExtended>) => {

    const homeUrl = getAdjustedSlug(ROUTES.HOME);
    const redirectionTarget = product?.value?._categories?.[0]?.slug || homeUrl;

    if (productGetters.getIsPublished(product?.value) === false ||
        productGetters.getEligibleForSellingOnCurrentMarket(product?.value) === false) {

      return createRedirectTarget(redirectionTarget, NON_PUBLISHED_OR_NON_ELIGIBLE_REDIRECTION_CODE);

    }

  };

  return {
    redirectIfProductSlugMismatch,
    isRedirecting,
    redirectIfNotPublishedOrNotEligibleForSelling,
  };

}
